import React from 'react';

export const SuccessIcon = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 20.25C7.44365 20.25 3.75 16.5563 3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 16.5563 16.5563 20.25 12 20.25ZM2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12ZM10.6583 14.816C10.7931 14.939 10.9648 15 11.1365 15C11.3183 15 11.4995 14.9319 11.6365 14.7958L15.5503 10.9071C15.8204 10.6386 15.816 10.2074 15.5402 9.94441C15.2645 9.68143 14.8216 9.68578 14.5514 9.95421L11.1158 13.3676L9.42735 11.8267C9.14548 11.5697 8.70309 11.5833 8.43912 11.8577C8.17514 12.1322 8.18912 12.5629 8.47099 12.8199L10.6583 14.816Z"
            fill="#00AC31"
        />
    </svg>
);

export const BackChevronIcon = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15.75 19.5L8.25 12L15.75 4.5"
            stroke="#6A6873"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const CloseCircleIcon = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM14.8467 8.03906C15.1378 7.74238 15.6152 7.74022 15.9092 8.03418C16.1989 8.32414 16.201 8.79318 15.9141 9.08594L13.0576 12L15.9141 14.9141C16.201 15.2068 16.1989 15.6759 15.9092 15.9658C15.6152 16.2598 15.1378 16.2576 14.8467 15.9609L12 13.0576L9.15332 15.9609C8.86217 16.2576 8.38478 16.2598 8.09082 15.9658C7.80106 15.6759 7.79897 15.2068 8.08594 14.9141L10.9424 12L8.03906 9.15332C7.74236 8.86217 7.74021 8.38479 8.03418 8.09082C8.32415 7.80104 8.79317 7.79895 9.08594 8.08594L12 10.9424L14.8467 8.03906Z"
            fill="#6A6873"
        />
    </svg>
);

export const ErrorIcon = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.0001 9.07141C12.4974 9.07141 12.9005 9.47455 12.9005 9.97185L12.8974 10.0466L12.5268 14.4943C12.5057 14.7479 12.2937 14.943 12.0392 14.943H11.961C11.7065 14.943 11.4945 14.7479 11.4734 14.4943L11.1028 10.0466C11.0615 9.55105 11.4297 9.11582 11.9253 9.07452C11.9502 9.07245 11.9751 9.07141 12.0001 9.07141Z"
            fill="#E42727"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 16.2866C12.4536 16.2866 12.8213 16.6543 12.8213 17.1079C12.8213 17.5615 12.4536 17.9292 12 17.9292C11.5464 17.9292 11.1787 17.5615 11.1787 17.1079C11.1787 16.6543 11.5464 16.2866 12 16.2866Z"
            fill="#E42727"
        />
        <path
            d="M12.0015 2.66711C12.7847 2.66769 13.4419 3.15205 13.8728 3.84924L22.3242 17.5221L22.4202 17.6854C22.8781 18.506 23.0127 19.4063 22.5908 20.1661C22.1404 20.9774 21.2196 21.3329 20.2061 21.3329H3.7947C2.78234 21.3329 1.86056 20.9794 1.4092 20.1683C0.957951 19.3575 1.14224 18.3865 1.67654 17.5221L10.128 3.84924L10.2114 3.72034C10.6425 3.09152 11.2669 2.66661 12.0015 2.66711ZM12.0008 4.16711C11.9042 4.16704 11.7109 4.2178 11.4968 4.5011L11.4038 4.63806L2.95241 18.3109C2.57385 18.9234 2.63444 19.2857 2.7195 19.4388C2.80453 19.5916 3.07949 19.8329 3.7947 19.8329H20.2061C20.9197 19.8329 21.1945 19.5917 21.2798 19.4381C21.3548 19.3029 21.4099 19.0078 21.1699 18.5277L21.0484 18.3109L12.5969 4.63806C12.3479 4.23517 12.1117 4.16731 12.0008 4.16711Z"
            fill="#E42727"
        />
    </svg>
);
